import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Swagger = makeShortcode("Swagger");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentation"
    }}>{`Documentation`}</h1>
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <p>{`Ticket Distribution is a service that can be used to show travel information of a ticket for both NOD and ID-based tickets. This makes it easier for clients to show relevant information to customers by using just one service, instead of having to go directly to NOD or ID-Based ticketing. It contains information like the origin and destination stops where the ticket is valid, the validity times,
possible supplement products, seat reservations.`}</p>
    <p>{`Additionally, Ticket Distribution has a few services to make it easier to manipulate tickets in their respective ticketing systems. These services can differ between NOD and ID-Based tickets as specified below.`}</p>
    <h3 {...{
      "id": "services-for-nod"
    }}>{`Services for NOD`}</h3>
    <h4 {...{
      "id": "distribute"
    }}>{`Distribute`}</h4>
    <p>{`  Tickets can be distributed to NOD using the `}<inlineCode parentName="p">{`/v1/ticket-distribution-groups/distribute`}</inlineCode>{` endpoint.`}</p>
    <h4 {...{
      "id": "update-validity"
    }}>{`Update Validity`}</h4>
    <p>{`  The validity times of the ticket in NOD can be updated using the `}<inlineCode parentName="p">{`/v1/ticket-distribution-groups/update-validities`}</inlineCode>{` endpoint.`}</p>
    <h3 {...{
      "id": "services-for-id-based-tickets"
    }}>{`Services for ID-Based tickets`}</h3>
    <h4 {...{
      "id": "update-validity-1"
    }}>{`Update Validity`}</h4>
    <p>{`  The validity times of ID-based tickets can be updated using the `}<inlineCode parentName="p">{`/v1/ticket-distribution-groups/update-validities`}</inlineCode>{` endpoint.`}</p>
    <h4 {...{
      "id": "transferring-tickets-to-another-customer"
    }}>{`Transferring tickets to another customer`}</h4>
    <p>{`  An ID-based ticket can be transferred to another customer account. This is done by using the `}<inlineCode parentName="p">{`/v1/ticket-distribution-groups/transfer-distribution-holder`}</inlineCode>{` endpoint as found in the API spec.
However, there are limitations. Not all products are transferable and a ticket cannot be transferred if the journey has already started.`}</p>
    <h2 {...{
      "id": "domain-types"
    }}>{`Domain types`}</h2>
    <h3 {...{
      "id": "ticketdistributiongroup"
    }}>{`TicketDistributionGroup`}</h3>
    <p>{` Group of TicketDistributions. This always corresponds to an orderLine.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`There can be more than one TicketDistribution in each group, and there can be more than one TicketDistributionGroup connected to an order.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For example, an OrderLine with more than one leg might have more than one TicketDistribution, but only one TicketDistributionGroup.`}</p>
        <h3 parentName="li" {...{
          "id": "ticketdistribution"
        }}>{`TicketDistribution`}</h3>
        <p parentName="li">{` A TicketDistribution corresponds to a main product on an OrderLine and represents a single ticket. A TicketDistribution contains relevant travel information which can be used to show information about the ticket to the customer.
Examples of such information are:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The names and ids of the stops/zones the ticket is valid for.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Information about the product and userProfile such as the name and id.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The times the ticket is valid.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Supplement products that are valid for the ticket, such as a bike or a dog.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Seat reservations, information about the seat number and carriage number.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`In case of ID-based tickets the customer account and fareContract to which the ticket belongs.`}</p>
        <h3 parentName="li" {...{
          "id": "pdfticket"
        }}>{`PdfTicket`}</h3>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Printable PDF of a ticket, represents at least one TicketDistribution, and always one TicketDistributionGroup.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For example, that same OrderLine with more than one leg will have just one PDF, but that PDF might have several different TicketDistributions connected to it, so there could be several sheets with individual QR codes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`It is possible to send the PDF directly to the end-user via email by using the `}<inlineCode parentName="p">{`/v1/pdf-tickets/{orderId}/send`}</inlineCode>{` endpoint.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`There is support for sending the PDF with a custom template, which allows clients to use their own branding and design. This configuration is done by the Entur team, so please contact us if you want to use this feature. Things that can be customized are:`}
            <ul parentName="li">
              <li parentName="ul">{`The logo`}</li>
              <li parentName="ul">{`The header color`}</li>
              <li parentName="ul">{`The footer text, this can be used for example to add a disclaimer or other information that is relevant to the end-user such as a phone number to call in case of questions.`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "workflow"
    }}>{`Workflow`}</h2>
    <h3 {...{
      "id": "after-an-order-is-created"
    }}>{`After an order is created`}</h3>
    <p>{`After the Order is CONFIRMED, Ticket Distribution automatically creates TicketDistributions and TicketDistributionGroups. The following kafka events are produced:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionGroupCreated`}</inlineCode>{` for each TicketDistributionGroup created.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionAdded`}</inlineCode>{` for each TicketDistribution added to a TicketDistributionGroup.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`AllTicketDistributionGroupsForOrderVersionGenerated`}</inlineCode>{` when all TicketDistributionGroups for an order version are generated. This notifies that ticket-distribution has completed processing the Order.`}</li>
    </ul>
    <p>{`The statuses of the generated TicketDistributions will differ based on the fulfillmentMethod.`}</p>
    <ul>
      <li parentName="ul">{`For NOD tickets, the status will be `}<inlineCode parentName="li">{`CREATED`}</inlineCode>{`. The client needs to call the `}<inlineCode parentName="li">{`/v1/ticket-distribution-groups/distribute`}</inlineCode>{` endpoint to distribute the tickets to NOD.`}</li>
      <li parentName="ul">{`For ID-based tickets, the status will be `}<inlineCode parentName="li">{`DISTRIBUTED`}</inlineCode>{` and the client does not need to do anything further. The tickets are already available in the ID-based ticketing system.`}</li>
    </ul>
    <h3 {...{
      "id": "after-an-order-is-updated-which-results-in-a-new-version-of-said-order"
    }}>{`After an order is updated which results in a new version of said Order`}</h3>
    <p>{`If an order is updated, for example the product has changed or the validity has changed.
Ticket Distribution will automatically update the TicketDistributions and TicketDistributionGroups. The following kafka events are produced:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionCancelled`}</inlineCode>{` for each TicketDistribution that is no longer valid. The status of these TicketDistributions will be `}<inlineCode parentName="li">{`CANCELLED`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionAdded`}</inlineCode>{` for each new TicketDistribution added to a TicketDistributionGroup. For NOD tickets, the status will be `}<inlineCode parentName="li">{`CREATED`}</inlineCode>{`, and for ID-based tickets, the status will be `}<inlineCode parentName="li">{`DISTRIBUTED`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionGroupCreated`}</inlineCode>{` for each new TicketDistributionGroup created. (Corresponds to a new OrderLine being added to an Order)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`AllTicketDistributionGroupsForOrderVersionGenerated`}</inlineCode>{` when all TicketDistributionGroups for an order version are generated. This notifies that ticket-distribution has completed processing the Order.`}</li>
    </ul>
    <h3 {...{
      "id": "after-an-orderline-is-cancelled"
    }}>{`After an orderLine is cancelled`}</h3>
    <p>{`If an orderLine is cancelled, Ticket Distribution will automatically cancel the TicketDistributions. The following kafka events are produced:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionCancelled`}</inlineCode>{` for each TicketDistribution that is no longer valid. The status of these TicketDistributions will be `}<inlineCode parentName="li">{`CANCELLED`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "a-change-is-done-that-does-not-result-in-a-new-version-of-the-order"
    }}>{`A change is done that does not result in a new version of the Order`}</h3>
    <p>{`If a change is done that does not affect the Order version, for example a change of seats, a change of the validity time or a transfer, Ticket Distribution will automatically update the TicketDistributions and TicketDistributionGroups. The following kafka events are produced:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionCancelled`}</inlineCode>{` for each TicketDistribution that is no longer valid. The status of these TicketDistributions will be `}<inlineCode parentName="li">{`CANCELLED`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TicketDistributionAdded`}</inlineCode>{` for each new TicketDistribution added to a TicketDistributionGroup. For NOD tickets, the status will be `}<inlineCode parentName="li">{`CREATED`}</inlineCode>{`, and for ID-based tickets, the status will be `}<inlineCode parentName="li">{`DISTRIBUTED`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "pdf-ticketing"
    }}>{`PDF Ticketing`}</h3>
    <p>{`Ticket Distribution can also be used to generate and/or send PDF tickets to the end-user.
If a PDF ticket is requested by the user, the client should send a request to the `}<inlineCode parentName="p">{`/v1/pdf-tickets/{orderId}/createOrGet`}</inlineCode>{` endpoint.`}</p>
    <pre><code parentName="pre" {...{}}>{`- This does not require the TicketDistributionGroup to be manually created before calling the endpoint. The endpoint will, in fact, wait for the TicketDistributionGroup to be automatically created before generating the PDF.
`}</code></pre>
    <p>{`If the end-user requested the PDF tickets to be sent via email, use the `}<inlineCode parentName="p">{`/{orderId}/send`}</inlineCode>{` endpoint to send the PDFs to the specified email address.`}</p>
    <pre><code parentName="pre" {...{}}>{`- It is not necessary to use the \`/{orderId}/createOrGet\` endpoint first. These two endpoints are for different workflows - one is for receiving the PDF which the client can use as pleased, the other is for sending directly to the customer.
`}</code></pre>
    <p>{`If an Order is later credited or changed so that the tickets are no longer valid, the TicketDistributions will be cancelled, and new ones created if necessary.`}</p>
    <pre><code parentName="pre" {...{}}>{`- Note that PDF tickets still exist - though they will no longer give the end-user a right to travel.
- The client is responsible for verifying that a PDF ticket has not been changed or cancelled. This can be done by checking the Ticket Distribution status (see below).
`}</code></pre>
    <h2 {...{
      "id": "ticketdistribution-as-a-kafka-producer"
    }}>{`TicketDistribution as a Kafka-producer`}</h2>
    <p>{`TicketDistribution produce TicketDistributionGroupEvents. The Avro-schema for TicketDistributionEvents can be found in the `}<a parentName="p" {...{
        "href": "https://github.com/entur/ticket-distribution/blob/main/src/main/avro/TicketDistributionGroupEvent.avsc"
      }}>{`ticket-distribution-repo`}</a>{`: src/main/avro/TicketDistributionGroupEvent.avsc`}</p>
    <h3 {...{
      "id": "event-types"
    }}>{`Event-types`}</h3>
    <h4 {...{
      "id": "ticketdistributiongroupevents"
    }}>{`TicketDistributionGroupEvents`}</h4>
    <p>{`The following types of TicketDistributionGroupEvents are produced by TicketDistribution:`}</p>
    <ul>
      <li parentName="ul">{`TicketDistributionActivated`}
        <ul parentName="li">
          <li parentName="ul">{`NOT IN USE`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionAdded`}
        <ul parentName="li">
          <li parentName="ul">{`A TicketDistribution has been added to a TicketDistributionGroup.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionCancelled`}
        <ul parentName="li">
          <li parentName="ul">{`A TicketDistribution has been cancelled, this can happen if the OrderLine is cancelled or if the Order is updated and the TicketDistribution is no longer valid.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionCancelledExternally (NOD ONLY)`}
        <ul parentName="li">
          <li parentName="ul">{`A TicketDistribution has been cancelled externally, this can happen if the ticket is cancelled directly in NOD.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionDistributed`}
        <ul parentName="li">
          <li parentName="ul">{`A TicketDistribution has been distributed to the respective ticketing system, this can be either NOD or ID-based ticketing.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionExpired (NOD ONLY)`}
        <ul parentName="li">
          <li parentName="ul">{`NOD has expired the ticket.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionFailed (NOD ONLY)`}
        <ul parentName="li">
          <li parentName="ul">{`An error has occurred in NOD, the TicketDistribution is no longer valid, and a new TicketDistribution has been created which can be used to retry the distribution.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionGroupCreated`}
        <ul parentName="li">
          <li parentName="ul">{`A TicketDistributionGroup has been created, this corresponds to an OrderLine and happens automatically when an Order is confirmed`}</li>
        </ul>
      </li>
      <li parentName="ul">{`TicketDistributionPickedUp (NOD ONLY)`}
        <ul parentName="li">
          <li parentName="ul">{`The QR Code has been picked up from NOD and cannot be picked up again. This is used to prevent double usage of the QR Code.`}</li>
        </ul>
      </li>
    </ul>
    <h4 {...{
      "id": "allticketdistributiongroupsfororderversioncompletedevents"
    }}>{`AllTicketDistributionGroupsForOrderVersionCompletedEvents`}</h4>
    <p>{`The following types of AllTicketDistributionGroupsForOrderVersionCompletedEvents are produced by TicketDistribution.
Note that these are only produced once all TicketDistributionGroups for an orderVersion are processed.`}</p>
    <ul>
      <li parentName="ul">{`AllTicketDistributionGroupsForOrderVersionGenerated`}
        <ul parentName="li">
          <li parentName="ul">{`This event is produced when all TicketDistributionGroups for an order version are generated. This notifies that ticket-distribution has completed processing the Order.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`AllTicketDistributionGroupsForOrderVersionDistributed`}
        <ul parentName="li">
          <li parentName="ul">{`This event is produced when all TicketDistributions for an order version are distributed.`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "queues"
    }}>{`Queues`}</h3>
    <h4 {...{
      "id": "ticketdistributiongroupevents-1"
    }}>{`TicketDistributionGroupEvents`}</h4>
    <p>{`There is one queue per environment, and the queues are named as following:`}</p>
    <ul>
      <li parentName="ul">{`ticket-distribution-group-events-dev`}</li>
      <li parentName="ul">{`ticket-distribution-group-events-staging`}</li>
      <li parentName="ul">{`ticket-distribution-group-events-production`}</li>
    </ul>
    <h4 {...{
      "id": "allticketdistributiongroupsfororderversioncompletedevents-1"
    }}>{`AllTicketDistributionGroupsForOrderVersionCompletedEvents`}</h4>
    <p>{`There is one queue per environment, and the queues are named as following:`}</p>
    <ul>
      <li parentName="ul">{`all-ticket-distribution-groups-for-order-version-completed-events-dev`}</li>
      <li parentName="ul">{`all-ticket-distribution-groups-for-order-version-completed-events-staging`}</li>
      <li parentName="ul">{`all-ticket-distribution-groups-for-order-version-completed-events-production`}</li>
    </ul>
    <p>{`Contact Entur if you want to subscribe to these queues.`}</p>
    <h1 {...{
      "id": "ticket-distribution-api-reference"
    }}>{`Ticket Distribution API Reference`}</h1>
    <p><a parentName="p" {...{
        "href": "http://petstore.swagger.io/?url=https://api.entur.io/api-docs/ticket-distribution?group%3dpublic"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <Swagger url="https://api.entur.io/api-docs/ticket-distribution?group=public" baseUrl="https://api.entur.io/sales" mdxType="Swagger" />
l

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      